<template>
  <div class="container">
    <div class="header">
      <h2>货主管理</h2>
      <button @click="showAddDialog = true" class="add-btn">
        新增货主
      </button>
    </div>
    
    <table class="data-table">
      <thead>
        <tr>
          <th>序号</th>
          <th>货主名</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in ownerList" :key="item.ownerId">
          <td>{{ index + 1 }}</td>
          <td>{{ item.ownerName }}</td>
        </tr>
        <tr v-if="ownerList.length === 0">
          <td colspan="3" class="empty-message">暂无数据</td>
        </tr>
      </tbody>
    </table>

    <!-- 新增对话框 -->
    <div v-if="showAddDialog" class="dialog-overlay">
      <div class="dialog">
        <h3>新增货主</h3>
        <input 
          type="text" 
          v-model="newOwnerName" 
          placeholder="请输入货主名称"
          class="input-field"
        >
        <div class="dialog-buttons">
          <button @click="showAddDialog = false" class="cancel-btn">取消</button>
          <button @click="addOwner" class="confirm-btn">确认</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import adminrequest from '@/utils/adminrequest'

export default {
  data() {
    return {
      ownerList: [],
      showAddDialog: false,
      newOwnerName: ''
    };
  },
  mounted() {
    this.fetchOwnerData();
  },
  methods: {
    // 获取司机数据
    fetchOwnerData() {
      const options = {
        method: 'GET',
        url: '/admin/manage/others/getOwner'
      };

      adminrequest.request(options)
        .then(response => {
          if (response.data.code === 200) {
            this.ownerList = response.data.data;
          } else {
            console.error('获取数据失败:', response.data.message);
          }
        })
        .catch(error => {
          console.error('请求失败:', error);
        });
    },

    // 新增司机，使用FormData格式提交
    addOwner() {
      if (!this.newOwnerName.trim()) {
        alert('请输入司机名称');
        return;
      }

      const form = new FormData();
      form.append("ownerName", this.newOwnerName);

      const options = {
        method: 'POST',
        url: '/admin/manage/others/addOwner',
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        data: form
      };

      adminrequest.request(options)
        .then(response => {
          if (response.data.code === 200) {
            this.showAddDialog = false;
            this.newOwnerName = '';
            this.fetchOwnerData();
            alert('新增成功');
          } else {
            alert('新增失败: ' + response.data.message);
          }
        })
        .catch(error => {
          console.error('新增请求失败:', error);
          alert('新增失败，请重试');
        });
    }
  }
};
</script>

<style>
.container {
  max-width: 1000px;
  margin: 20px auto;
  padding: 0 20px;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.add-btn {
  background-color: #42b983;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.add-btn:hover {
  background-color: #359e75;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #e0e0e0;
}

.data-table th,
.data-table td {
  padding: 12px 15px;
  text-align: left;
  border-bottom: 1px solid #e0e0e0;
}

.data-table th {
  background-color: #f5f5f5;
  font-weight: bold;
}

.delete-btn {
  background-color: #f44336;
  color: white;
  border: none;
  padding: 4px 8px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
}

.delete-btn:hover {
  background-color: #d32f2f;
}

.empty-message {
  text-align: center;
  color: #757575;
  padding: 20px;
}

/* 对话框样式 */
.dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.dialog {
  background-color: white;
  padding: 20px;
  border-radius: 4px;
  width: 300px;
}

.input-field {
  width: 100%;
  padding: 8px;
  margin: 10px 0;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-sizing: border-box;
}

.dialog-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}

.cancel-btn {
  background-color: #e0e0e0;
  border: none;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
}

.confirm-btn {
  background-color: #42b983;
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
}
</style>
